import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import {
  RichTextSection,
  richTextHasContent,
  RichTextRender,
} from 'design-comuni-plone-theme/components/ItaliaTheme/View';

const messages = defineMessages({
  info_point: {
    id: 'info_point',
    defaultMessage: 'Contattaci',
  },
  phone_number: {
    id: 'phone_number',
    defaultMessage: 'Telefono',
  },
});

const IndirizzoContatti = ({ content }) => {
  const intl = useIntl();
  return (
    <>
      {(content.email ||
        content.pec ||
        richTextHasContent(content.phone) ||
        content.fax) && (
        <RichTextSection
          tag_id="info_point"
          title={intl.formatMessage(messages.info_point)}
        >
          {/* TABLE */}
          <div className="table">
            {richTextHasContent(content.phone) && (
              <div className="row">
                <div className="col col-h col-2">
                  {intl.formatMessage(messages.phone_number)}
                </div>
                <div className="col">
                  <RichTextRender data={content.phone} serif={false} />
                </div>
              </div>
            )}
            {content.email && (
              <div className="row">
                <div className="col col-h col-2">E-mail</div>
                <div className="col">
                  <a href={`mailto:${content.email}`}>{content.email}</a>
                </div>
              </div>
            )}
            {content.pec && (
              <div className="row">
                <div className="col col-h col-2">Pec</div>
                <div className="col">
                  <a href={`mailto:${content.pec}`}>{content.pec}</a>
                </div>
              </div>
            )}
            {content.fax && (
              <div className="row">
                <div className="col col-h col-2">Fax</div>
                <div className="col">{content.fax}</div>
              </div>
            )}
          </div>

          {/* LIST */}
          {/* {richTextHasContent(content.phone) && (
            <div className="d-flex">
              <div className="fw-bold me-2">
                {intl.formatMessage(messages.phone_number)}:
              </div>
              <RichTextRender
                data={content.phone}
                serif={false}
                add_class="rich-text"
              />
            </div>
          )}
          {content.email && (
            <div className="d-flex">
              <div className="fw-bold me-2">E-mail:</div>{' '}
              <a href={`mailto:${content.email}`}>{content.email}</a>
            </div>
          )}
          {content.pec && (
            <div className="d-flex">
              <div className="fw-bold me-2">Pec:</div>{' '}
              <a href={`mailto:${content.pec}`}>{content.pec}</a>
            </div>
          )}
          {content.fax && (
            <div className="d-flex">
              <div className="fw-bold me-2">Fax:</div> <div>{content.fax}</div>
            </div>
          )} */}
        </RichTextSection>
      )}
    </>
  );
};

export default IndirizzoContatti;
